import React, { FC } from "react"
import styled from "styled-components"
import { BlockTitle, Container } from "../shared"
import { Principle } from "./principle"

import lock from "../../images/principles/confidentional.svg"
import caseIcon from "../../images/principles/case.svg"
import clientInterests from "../../images/principles/client-interests.svg"
import ethic from "../../images/principles/etic.svg"
import { string } from "yargs"

const principlesData1 = [
  {
    title: "Отстаивания интересов клиентов",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    icon: lock,
  },
  {
    title: "Соблюдения конфиденциальности",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    icon: clientInterests,
  },
  {
    title: "Соблюдение адвокатской этики",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    icon: ethic,
  },
  {
    title: "Соблюдения конфиденциальности",
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua",
    icon: caseIcon,
  },
]

const PrinciplesContainer = styled.section`
  width: 100%;
  padding: 80px 0 120px;
  background: #f8f8f8;
`

export const Principles: FC<{
  title: string
  principleData: { title: string; text: string; icon: string }[]
}> = ({ principleData, title }) => {
  return (
    <PrinciplesContainer>
      <Container>
        <BlockTitle>{title}</BlockTitle>
        {principleData.map((data, index) => (
          <Principle
            key={index}
            text={data.text}
            title={data.title}
            icon={data.icon}
            isEven={index % 2 === 0}
            isLast={index === principleData.length - 1}
          />
        ))}
      </Container>
    </PrinciplesContainer>
  )
}
